import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentChangeRequest: null,
  error: null,
  loading: false,
};

const changeRequestSlice = createSlice({
  name: "changeRequest",
  initialState,
  reducers: {
    setCurrentChangeRequest: (state, action) => {
      state.currentChangeRequest = action.payload;
    },
    clearCurrentChangeRequest: (state) => {
      state.currentChangeRequest = null;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setCurrentChangeRequest,
  clearCurrentChangeRequest,
  setError,
  setLoading,
} = changeRequestSlice.actions;

export default changeRequestSlice.reducer;